import {IDTokenProvider, Role, TenantUser} from '@br/idm-api';

export const shouldShowRole: ({user, role}: {user: TenantUser | null; role: Role}) => boolean = ({user, role}) => {
    // If this role only has Azure as the login provider, don't show it in the dropdown.
    // However, if the user already has this role, show it to avoid confusing people.
    const azureOnly = role.loginProviders.length === 1 && role.loginProviders[0] === IDTokenProvider.TenantAzure;
    if (!user) {
        return !azureOnly;
    }
    return !azureOnly || user.roles.includes(role.id);
};
